var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1483)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FF3239",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4624 23.4624C21.9524 23.4624 21.4632 23.6651 21.1025 24.0257C20.7419 24.3864 20.5392 24.8756 20.5392 25.3857C20.5392 25.8957 20.7419 26.3849 21.1025 26.7456C21.4632 27.1062 21.9524 27.3089 22.4624 27.3089C22.9725 27.3089 23.4617 27.1062 23.8224 26.7456C24.183 26.3849 24.3857 25.8957 24.3857 25.3857C24.3857 24.8756 24.183 24.3864 23.8224 24.0257C23.4617 23.6651 22.9725 23.4624 22.4624 23.4624ZM22.4624 23.4624H15.0523C14.609 23.4624 14.3869 23.4624 14.2042 23.3836C14.0432 23.3142 13.9042 23.2022 13.8022 23.0595C13.6869 22.8989 13.6417 22.6845 13.5513 22.2614L11.1828 11.2164C11.0905 10.7827 11.0434 10.5654 10.928 10.4039C10.8259 10.2607 10.6866 10.1483 10.5251 10.0789C10.3434 10 10.1222 10 9.67985 10H9M11.8848 12.8848H24.2635C24.9578 12.8848 25.304 12.8848 25.5377 13.0291C25.7418 13.1559 25.891 13.3545 25.956 13.5858C26.03 13.8493 25.9348 14.183 25.7425 14.8494L24.4107 19.4651C24.2953 19.8641 24.2376 20.0632 24.1222 20.2113C24.0189 20.3421 23.8833 20.4438 23.7289 20.5065C23.5558 20.5776 23.3481 20.5776 22.9356 20.5776H13.5484M13.808 27.3089C13.298 27.3089 12.8088 27.1062 12.4481 26.7456C12.0874 26.3849 11.8848 25.8957 11.8848 25.3857C11.8848 24.8756 12.0874 24.3864 12.4481 24.0257C12.8088 23.6651 13.298 23.4624 13.808 23.4624C14.3181 23.4624 14.8073 23.6651 15.1679 24.0257C15.5286 24.3864 15.7312 24.8756 15.7312 25.3857C15.7312 25.8957 15.5286 26.3849 15.1679 26.7456C14.8073 27.1062 14.3181 27.3089 13.808 27.3089Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainShoppingCart);
export default __webpack_public_path__ + "static/media/icon-main-shopping-cart.050c99fcd86495b90638090718bc83d6.svg";
export { ForwardRef as ReactComponent };